import React, { Component } from 'react'
import * as R from "ramda";
import SimpleDataTable from '../../../../../../modules/SimpleDataTable'
import { CONFIG_REPORT_STATISTIC_PROSPECT_TODAY} from '../config'
import { HttpStatus } from "../../../../../common/Constants";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";

export default class ReportAppointmentFollowupToday extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: [],
      dataTable: [],
    };
  };

  componentDidMount() {
    this.setState((prevValue) => ({
      ...prevValue,
      tableConfig: CONFIG_REPORT_STATISTIC_PROSPECT_TODAY,
    }));
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
      this.fetchData(this.props.search);
      this.props.onSearchValueChange("doSearch", false);
    }
  };

  fetchData = async (payload) => {
    let res = {};
    this.props.triggerLoading();
    res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanAppointmentFUToDay,
      menuName: "Dashboard Kacab dan Admin CRM - Laporan Appointment Follow Up Hari Ini",
      setError: this.props.setError,
      args: payload,
    });

    console.log(res);


    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data || []
      }));
    }
    this.props.triggerLoading();
  };

  render() {
    return (
      <div style={{ padding: "10px" }}>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN APPOINTMENT FOLLOW UP HARI INI
        </p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </div>
    );
  }
}
